import React, { forwardRef } from 'react';
import { MenuGroup as MenuGroupNew } from './MenuGroup';
import { convertOldMenuGroupProps } from './converter.old';
import type { OldMenuGroupProps } from './converter.old';

export type MenuGroupProps = OldMenuGroupProps;

export const MenuGroup = forwardRef<HTMLLIElement, MenuGroupProps>((props, ref) => (
  <MenuGroupNew {...convertOldMenuGroupProps(props)} ref={ref} />
));
